import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initPwa } from '@/modules/pwa'
import './styles/globals.css'

// inicializa PWA (manifest dinâmico + SW)
initPwa()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
